
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hnaviCategory]/feature/page/[pageNo]",
      function () {
        return require("private-next-pages/[hnaviCategory]/feature/page/[pageNo].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hnaviCategory]/feature/page/[pageNo]"])
      });
    }
  